import dynamic from 'next/dynamic'

const LazyBazaarVoiceScript = dynamic(
  async () => {
    const mod = await import('./BazaarVoiceScript')
    return mod.default
  },
  {
    ssr: false,
  }
)

export default LazyBazaarVoiceScript
